import React from 'react';
import classNames from 'classnames';
import Styles from './table-header-column.less';

const baseClass = Styles.th;

module.exports = React.createClass({
  displayName: 'TableHeaderColumn',
  propTypes: {
    className: React.PropTypes.string
  },
  getChildren() {
    return this.props.children
  },
  getClass() {
    return classNames(baseClass, this.props.className);
  },
  render: require('./table-header-column.rt')
});



/** WEBPACK FOOTER **
 ** ./src/table/table-header-column/table-header-column.js
 **/